/* Beasock Halloween effects: Halloween logo intro, witch hat on the header logo, garland with
   spiders, flying bats, a peeking ghost, falling leaves, a graveyard above the footer and a
   candy burst on add to cart. Loaded by the top bar only while Halloween mode is on. */
(function () {
  if (window.__bskhw) return;
  window.__bskhw = 1;
  var C = window.BSKHW || {};
  var doc = document, html = doc.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bot = /bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent) || navigator.webdriver;
  var design = window.Shopify && window.Shopify.designMode;
  var wide = function () { return innerWidth >= 990; };

  var BAT = '<svg viewBox="0 0 64 30" aria-hidden="true"><path d="M32 11c-1.6-3.6-3.4-5.6-5.4-6.2.6 1.8.6 3.4 0 4.8C22.8 6 15.4 5 7 7.4c3.6 1.8 5 4.6 4.6 8.2-3.4-1.4-7-1.2-10.6.8 5.8.4 9.4 2.6 11 6.4 2.6-2.4 6-3.2 9.6-2.4 1.8 2.6 5.2 4.6 10.4 6.6 5.2-2 8.6-4 10.4-6.6 3.6-.8 7 0 9.6 2.4 1.6-3.8 5.2-6 11-6.4-3.6-2-7.2-2.2-10.6-.8-.4-3.6 1-6.4 4.6-8.2-8.4-2.4-15.8-1.4-19.6 2.2-.6-1.4-.6-3 0-4.8-2 .6-3.8 2.6-5.4 6.2z"/></svg>';
  var HAT = '<svg viewBox="0 0 120 92" aria-hidden="true"><ellipse cx="60" cy="78" rx="56" ry="12" fill="#1c1230"/><path d="M36 76 58 10q3-7 9-4 11 6 25 24-12-6-18-2l10 48z" fill="#2a1747"/><path d="M38 64h44l2 10H36z" fill="#ff8a1f"/><rect x="53" y="63" width="14" height="12" rx="2" fill="none" stroke="#ffd166" stroke-width="3"/></svg>';
  var SPIDER = '<svg viewBox="0 0 40 32" aria-hidden="true"><path d="M14 14 4 6M14 17 2 16M14 20 4 27M16 22l-6 9M26 14l10-8M26 17l12-1M26 20l10 7M24 22l6 9" stroke="#1c1230" stroke-width="2.4" stroke-linecap="round" fill="none"/><ellipse cx="20" cy="18" rx="8" ry="9" fill="#1c1230"/><circle cx="20" cy="9" r="5" fill="#1c1230"/><circle cx="18" cy="9" r="1.4" fill="#fff"/><circle cx="22" cy="9" r="1.4" fill="#fff"/></svg>';
  var WEB = '<svg viewBox="0 0 120 120" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M0 0l120 120M0 0l60 120M0 0l120 60M0 0v120M0 0h120"/><path d="M0 28q14-2 18-14t10-14M0 56q28-4 36-28t20-28M0 86q42-6 54-42t30-44M0 114q56-8 72-56t40-58"/></svg>';
  var PUMPKIN = '<svg viewBox="0 0 64 58" aria-hidden="true"><path d="M33 13c-1.2-4.6.2-8.6 4.6-11l2.2 2.6c-3.2 1.8-4.2 4.6-3.6 8.4z" fill="#4f7d3c"/><ellipse cx="19" cy="35" rx="16" ry="19" fill="#f07a12"/><ellipse cx="45" cy="35" rx="16" ry="19" fill="#f07a12"/><ellipse cx="32" cy="35" rx="15" ry="21.5" fill="#ff9a2e"/><path d="M22 30l5-6 5 6zM36 30l5-6 5 6zM21 39c4 6 18 6 22 0-2.6 1.4-4.6 2-6 2l-1.6 2.6-2-2.4h-3.2l-2 2.4L26.6 41c-1.4 0-3.4-.6-5.6-2z" fill="#2a1747"/></svg>';
  var GHOST = '<svg viewBox="0 0 80 96" aria-hidden="true"><path d="M40 4C20 4 8 20 8 40v48l10-8 10 8 12-8 12 8 10-8 10 8V40C72 20 60 4 40 4z" fill="#fff" stroke="#e6dff0" stroke-width="2"/><ellipse cx="30" cy="40" rx="5" ry="7" fill="#1c1230"/><ellipse cx="50" cy="40" rx="5" ry="7" fill="#1c1230"/><ellipse cx="40" cy="56" rx="6" ry="5" fill="#1c1230"/><ellipse cx="23" cy="50" rx="5" ry="3" fill="#ffb3c1"/><ellipse cx="57" cy="50" rx="5" ry="3" fill="#ffb3c1"/></svg>';
  var LEAF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2c3 4 9 5 9 11 0 5-4 9-9 9s-9-4-9-9C3 7 9 6 12 2z" fill="currentColor"/><path d="M12 6v16" stroke="rgba(0,0,0,.25)" stroke-width="1.2"/></svg>';
  function inner(s) { return s.replace(/<\/?svg[^>]*>/g, ''); }
  function el(tag, cls, h) { var e = doc.createElement(tag); if (cls) e.className = cls; if (h) e.innerHTML = h; return e; }

  function header() {
    var link = doc.querySelector('.header__heading-link');
    if (link && !link.querySelector('.bskhw-hat')) {
      link.classList.add('bskhw-logo');
      link.appendChild(el('span', 'bskhw-hat', HAT));
      link.appendChild(el('span', 'bskhw-orbit', '<span class="bskhw-orbit__bat">' + BAT + '</span>'));
    }
    var hw = doc.querySelector('.header-wrapper');
    if (hw && !hw.querySelector('.bskhw-web')) {
      hw.classList.add('bskhw-hdr');
      hw.appendChild(el('span', 'bskhw-web bskhw-web--l', WEB));
      hw.appendChild(el('span', 'bskhw-web bskhw-web--r', WEB));
    }
    if (doc.querySelector('.bskhw-garland')) return;
    var secs = [].filter.call(doc.querySelectorAll('.shopify-section-group-header-group'), function (s) { return s.offsetHeight > 0 && !s.querySelector('.bskh-ann'); });
    var host = secs[secs.length - 1];
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var g = el('div', 'bskhw-garland');
    [9, 31, 58, 84].forEach(function (x, i) {
      if (!wide() && i % 2) return;
      var s = el('span', 'bskhw-spider s' + i, '<i></i>' + SPIDER);
      s.style.left = x + '%';
      g.appendChild(s);
    });
    host.appendChild(g);
  }

  function flock() {
    if (doc.hidden || reduce) return;
    var n = wide() ? 4 + Math.floor(Math.random() * 3) : 3;
    var layer = el('div', 'bskhw-flock');
    layer.style.top = (6 + Math.random() * 34) + 'vh';
    var dur = 9 + Math.random() * 5;
    for (var i = 0; i < n; i++) {
      var b = el('span', 'bskhw-fb', BAT);
      b.style.animationDuration = dur + 's';
      b.style.animationDelay = (i * 0.38 + Math.random() * 0.3) + 's';
      b.style.top = Math.round(Math.random() * 60) + 'px';
      b.style.width = (20 + Math.random() * 22) + 'px';
      b.style.setProperty('--dy1', Math.round(Math.random() * 60 - 30) + 'px');
      b.style.setProperty('--dy2', Math.round(Math.random() * 60 - 30) + 'px');
      layer.appendChild(b);
    }
    doc.body.appendChild(layer);
    setTimeout(function () { layer.remove(); }, (dur + 3) * 1000);
  }

  var ghost;
  function peek() {
    if (doc.hidden || reduce || !wide()) return;
    if (!ghost) {
      ghost = el('a', 'bskhw-ghost', GHOST + '<span class="bskhw-ghost__boo">Boo!</span>');
      ghost.href = C.url || '/collections/halloween';
      ghost.setAttribute('aria-label', 'Open the Halloween Shop');
      doc.body.appendChild(ghost);
    }
    ghost.classList.add('is-on');
    setTimeout(function () { ghost.classList.remove('is-on'); }, 3600);
  }

  function leaves() {
    if (reduce) return;
    var colors = ['#e07a1f', '#c8551b', '#b8860b', '#a0522d', '#d9822b'];
    var n = wide() ? 8 : 4;
    for (var i = 0; i < n; i++) {
      var l = el('span', 'bskhw-leaf', LEAF);
      l.style.left = Math.round(Math.random() * 96) + 'vw';
      l.style.color = colors[i % colors.length];
      l.style.width = (14 + Math.random() * 12) + 'px';
      l.style.setProperty('--d', (11 + Math.random() * 10) + 's');
      l.style.setProperty('--delay', (-Math.random() * 20) + 's');
      l.style.setProperty('--sx', Math.round(Math.random() * 160 - 80) + 'px');
      doc.body.appendChild(l);
    }
  }

  function yard() {
    var f = doc.querySelector('.shopify-section-group-footer-group');
    if (!f || doc.querySelector('.bskhw-yard')) return;
    var fence = '';
    for (var x = 690; x < 860; x += 16) fence += 'M' + x + ' 104v-24l4-7 4 7v24z';
    var stones = [[120, 'RIP'], [196, ''], [930, 'BOO'], [1010, '']].map(function (s, i) {
      var h = i % 2 ? 26 : 34;
      return '<path d="M' + s[0] + ' 106v-' + h + 'a16 16 0 0 1 32 0v' + h + 'z" fill="#2a1747"/>' + (s[1] ? '<text x="' + (s[0] + 16) + '" y="' + (116 - h) + '" font-size="10" text-anchor="middle" fill="#9b84c4" font-family="Georgia,serif">' + s[1] + '</text>' : '');
    }).join('');
    var pk = function (x, y, w) { return '<svg x="' + x + '" y="' + y + '" width="' + w + '" height="' + Math.round(w * 0.9) + '" viewBox="0 0 64 58" class="bskhw-glow">' + inner(PUMPKIN) + '</svg>'; };
    var y = el('div', 'bskhw-yard',
      '<svg viewBox="0 0 1200 120" preserveAspectRatio="xMidYMax slice" aria-hidden="true">' +
      '<circle cx="1080" cy="34" r="22" fill="#ffe9a8" opacity=".95"/>' +
      '<g fill="#1c1230" transform="translate(1000 22) scale(.45)">' + inner(BAT) + '</g>' +
      '<g fill="#1c1230" transform="translate(1110 52) scale(.35)">' + inner(BAT) + '</g>' +
      '<path d="M0 120V96q150-24 300-6t300-6 300 6 300-12v42z" fill="#1c1230"/>' +
      '<path d="M60 104c2-30-2-48 6-70M64 56 44 44M66 44l18-14M62 68l-22-6" stroke="#1c1230" stroke-width="7" stroke-linecap="round" fill="none"/>' +
      stones + '<path d="M410 106V70m-11 11h22M470 106V78m-9 9h18" stroke="#2a1747" stroke-width="6"/>' +
      '<path d="' + fence + '" fill="#1c1230"/><path d="M690 86h170" stroke="#1c1230" stroke-width="4"/>' +
      pk(300, 78, 40) + pk(560, 84, 30) + pk(880, 80, 36) +
      '<text x="600" y="58" text-anchor="middle" font-family="Caveat,Segoe Print,cursive" font-size="30" font-weight="600" fill="#ffb35c">Happy Halloween from Beasock!</text></svg>');
    f.parentNode.insertBefore(y, f);
  }

  function burst(x, y) {
    if (reduce) return;
    var bits = ['🎃', '🍬', '👻', '🦇', '🍭', '🕸️'];
    for (var i = 0; i < 12; i++) {
      var s = el('span', 'bskhw-burst');
      s.textContent = bits[i % bits.length];
      var a = (Math.PI * 2 * i) / 12 + Math.random() * 0.4, d = 70 + Math.random() * 90;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--x', Math.round(Math.cos(a) * d) + 'px');
      s.style.setProperty('--y', Math.round(Math.sin(a) * d - 40) + 'px');
      s.style.setProperty('--r', Math.round(Math.random() * 160 - 80) + 'deg');
      doc.body.appendChild(s);
      setTimeout(function (e) { e.remove(); }.bind(null, s), 1100);
    }
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name="add"], .product-form__submit, .bskh-card__add, .quick-add__submit');
    if (!b || b.disabled) return;
    var r = b.getBoundingClientRect();
    burst(e.clientX || r.left + r.width / 2, e.clientY || r.top + r.height / 2);
  });

  function popHat() {
    var w = doc.querySelector('.bskw-pop__wrap');
    if (w && !w.querySelector('.bskhw-pophat')) w.appendChild(el('span', 'bskhw-pophat', HAT));
  }

  function intro() {
    if (!C.intro || bot || design || !C.logo) return;
    var imgs = C.parts
      ? ['pad', 'tl', 'tt', 'tr', 'word'].map(function (p) { return '<img class="bskw-p bskw-p--' + p + '" src="' + C.logo + '" alt="" width="500" height="655">'; }).join('')
      : '<img class="bskw-p bskw-p--all" src="' + C.logo + '" alt="">';
    var bats = '';
    for (var i = 1; i <= 6; i++) bats += '<span class="bskhw-ib b' + i + '">' + BAT + '</span>';
    var o = el('div', 'bskhw-intro',
      '<div class="bskhw-intro__stage"><div class="bskhw-intro__moon"></div>' + bats +
      '<div class="bskw-intro__logo bskhw-intro__logo" style="aspect-ratio:' + (C.ar || 0.76) + '">' + imgs + '</div>' +
      '<span class="bskhw-intro__hat">' + HAT + '</span><span class="bskhw-intro__spider"><i></i>' + SPIDER + '</span></div>' +
      '<p class="bskhw-intro__hello">Happy Halloween!</p><p class="bskhw-intro__tag">Spooky-cute finds for cats &amp; dogs</p>' +
      '<div class="bskhw-intro__pk">' + PUMPKIN + PUMPKIN + PUMPKIN + '</div><button type="button" class="bskhw-intro__skip">Skip</button>');
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.setAttribute('aria-label', 'Happy Halloween from Beasock');
    html.classList.add('bskhw-intro-on', 'bskhw-lock');
    doc.body.appendChild(o);
    requestAnimationFrame(function () { requestAnimationFrame(function () { o.classList.add('is-on'); }); });
    var done = false;
    function end() {
      if (done) return;
      done = true;
      try { localStorage.setItem('bskw_hw_intro', '1'); localStorage.setItem('bskw_intro', '1'); } catch (e) {}
      o.classList.add('is-leaving');
      setTimeout(function () { o.remove(); html.classList.remove('bskhw-intro-on', 'bskhw-lock'); }, 500);
    }
    o.addEventListener('click', end);
    doc.addEventListener('keydown', function k(e) { if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') { doc.removeEventListener('keydown', k); end(); } });
    setTimeout(end, reduce ? 1800 : 4800);
  }

  function boot() {
    intro();
    header();
    yard();
    leaves();
    popHat();
    if (!bot && !reduce) {
      setTimeout(flock, 3500);
      setInterval(flock, 21000);
      setTimeout(peek, 14000);
      setInterval(peek, 46000);
    }
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { header(); popHat(); }, 300); }).observe(doc.body, { childList: true });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();